import React, { memo } from 'react';
import { Book, Heart, PenTool, Sparkles, Calendar } from 'lucide-react';
import { Section, CTAButton } from './Shared';
import { Pricing } from './Pricing';
const bonuses = [{
  icon: PenTool,
  title: 'BONUS 1 — PALABRAS PARA MAMÁ',
  subtitle: 'Guía de Escritura Sanadora',
  color: 'text-brand-pink',
  bgColor: 'bg-brand-pink/10',
  borderColor: 'border-brand-pink/30',
  desc: 'Invitaciones guiadas para decirle a mamá todo lo que quedó guardado. Te dice exactamente qué escribir y cómo empezar, sin enfrentarte a una hoja en blanco.',
  result: '✅ Por fin podés expresar lo que no llegaste a decirle',
  price: '$12.990'
}, {
  icon: Book,
  title: 'BONUS 2 — CUADERNO DE SANACIÓN',
  subtitle: 'Espacio Íntimo',
  color: 'text-brand-goldDark',
  bgColor: 'bg-brand-gold/10',
  borderColor: 'border-brand-gold/30',
  desc: 'Un espacio íntimo para volcar lo que sentís, ordenar el dolor y observar tu proceso con compasión. Con preguntas y ejercicios simples que te guían en cada momento difícil.',
  result: '✅ El duelo necesita un lugar concreto donde expresarse',
  price: '$15.990'
}, {
  icon: Calendar,
  title: 'BONUS 3 — RITUAL DE LOS 7 DÍAS',
  subtitle: 'Práctica Espiritual',
  color: 'text-brand-dark',
  bgColor: 'bg-brand-dark/10',
  borderColor: 'border-brand-dark/30',
  desc: 'Una práctica espiritual diaria para acompañarte paso a paso desde el dolor más intenso hacia la paz interior. Simple, concreto y para hacer en casa.',
  result: '✅ Siete días para empezar a sentir su amor de una nueva forma',
  price: '$9.990'
}];
export const MethodOverview = () => {
  return <Section id="method" className="relative" data-id="element-211">
      <div className="text-center mb-12" data-id="element-212">
        <div className="inline-flex items-center space-x-2 bg-white border border-brand-pink/40 px-4 py-1.5 rounded-full mb-6 shadow-sm" data-id="element-213">
          <span className="text-xl" data-id="element-214">🌿</span>
          <span className="font-serif font-semibold tracking-wider text-brand-pink text-sm md:text-base uppercase" data-id="element-215">
            Santuario Digital: Mamá Sigue Aquí™
          </span>
        </div>
        <h2 className="text-2xl md:text-5xl font-display font-bold mb-4 leading-tight text-brand-pinkDark" data-id="element-216">
          1 Tomo Principal + 3 Bonus
        </h2>
        <p className="text-brand-text/70 text-base md:text-lg" data-id="element-217">
          Todo el acompañamiento que necesitás.
        </p>
      </div>

      <div className="max-w-4xl mx-auto mb-12" data-id="element-218">
        <div className="rounded-2xl p-6 md:p-8 border bg-brand-pink/5 border-brand-pink/25 backdrop-blur-sm shadow-sm mb-6" data-id="element-219">
          <div className="flex flex-col md:flex-row md:items-start gap-4 md:gap-6" data-id="element-220">
            <div className="shrink-0 mx-auto md:mx-0 w-24 md:w-32 flex items-center justify-center" data-id="element-221">
              <img src="https://cdn.magicpatterns.com/uploads/nhyPCvSHfL8Y2mQFJgFE2A/ChatGPT_Image_7_jul_2026,_06_07_18_p.m..png" alt="Tomo Principal — Mamá Sigue Aquí" className="w-24 md:w-32 h-auto rounded-md shadow-lg ring-1 ring-brand-pink/15 object-cover" draggable={false} data-id="element-222" />
            </div>
            <div className="flex-grow" data-id="element-223">
              <h4 className="font-serif font-bold mb-2 text-lg text-brand-pinkDark" data-id="element-224">
                TOMO PRINCIPAL — MAMÁ SIGUE AQUÍ
              </h4>
              <p className="text-brand-text/90 font-medium mb-2 text-base" data-id="element-225">
                Acompañamiento espiritual completo para el duelo materno
              </p>
              <p className="text-brand-text/80 text-sm mb-4" data-id="element-226">
                El refugio espiritual central para atravesar el duelo de la
                pérdida física de tu madre. Una guía de 100 páginas que fusiona
                espiritualidad práctica con ejercicios emocionales para
                transformar el dolor en paz interior y conexión amorosa.
              </p>

              <div className="bg-white/80 p-4 rounded-lg border border-brand-pink/15 mb-4" data-id="element-227">
                <p className="text-xs font-bold uppercase tracking-wider text-brand-pink mb-3" data-id="element-228">
                  6 Estaciones de Sanación incluidas
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-1.5 text-xs md:text-sm text-brand-text/85" data-id="element-229">
                  <div className="flex items-start" data-id="element-230">
                    <span className="text-brand-gold mr-2 shrink-0" data-id="element-231">·</span>
                    <span data-id="element-232">El dolor de perder físicamente a mamá</span>
                  </div>
                  <div className="flex items-start" data-id="element-233">
                    <span className="text-brand-gold mr-2 shrink-0" data-id="element-234">·</span>
                    <span data-id="element-235">Lo que me quedó por decirle</span>
                  </div>
                  <div className="flex items-start" data-id="element-236">
                    <span className="text-brand-gold mr-2 shrink-0" data-id="element-237">·</span>
                    <span data-id="element-238">La culpa, el perdón y los asuntos inconclusos</span>
                  </div>
                  <div className="flex items-start" data-id="element-239">
                    <span className="text-brand-gold mr-2 shrink-0" data-id="element-240">·</span>
                    <span data-id="element-241">La nueva forma de sentir su amor y presencia</span>
                  </div>
                  <div className="flex items-start" data-id="element-242">
                    <span className="text-brand-gold mr-2 shrink-0" data-id="element-243">·</span>
                    <span data-id="element-244">Cómo honrar su memoria sin congelar tu vida</span>
                  </div>
                  <div className="flex items-start" data-id="element-245">
                    <span className="text-brand-gold mr-2 shrink-0" data-id="element-246">·</span>
                    <span data-id="element-247">
                      Vivir como homenaje sin sentir que la traicionás
                    </span>
                  </div>
                </div>
              </div>

              <div className="bg-white/80 p-4 rounded-lg border border-brand-pink/15" data-id="element-248">
                <p className="text-xs font-bold uppercase tracking-wider text-brand-pink mb-3" data-id="element-249">
                  Cada estación incluye
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-3 gap-y-1.5 text-xs md:text-sm text-brand-text/85" data-id="element-250">
                  <div className="flex items-center" data-id="element-251">
                    <span data-id="element-252">✅ Explicación espiritual y emocional</span>
                  </div>
                  <div className="flex items-center" data-id="element-253">
                    <span data-id="element-254">✅ Ejercicios guiados de reflexión</span>
                  </div>
                  <div className="flex items-center" data-id="element-255">
                    <span data-id="element-256">✅ Frases de contención</span>
                  </div>
                  <div className="flex items-center" data-id="element-257">
                    <span data-id="element-258">✅ Invitaciones a la escritura</span>
                  </div>
                  <div className="flex items-center" data-id="element-259">
                    <span data-id="element-260">✅ Rituales simbólicos simples</span>
                  </div>
                  <div className="flex items-center" data-id="element-261">
                    <span data-id="element-262">✅ Prácticas de conexión interior</span>
                  </div>
                  <div className="flex items-center" data-id="element-263">
                    <span data-id="element-264">✅ Protocolos para fechas gatillo</span>
                  </div>
                  <div className="flex items-center" data-id="element-265">
                    <span data-id="element-266">✅ Cierre espiritual de cada etapa</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mb-8" data-id="element-267">
          <h3 className="text-xl md:text-2xl font-serif font-bold text-brand-pinkDark" data-id="element-268">
            🎁 3 BONUS DE REGALO
          </h3>
          <p className="text-xs md:text-sm uppercase tracking-wider text-brand-goldDark mt-1 font-bold" data-id="element-269">
            SIEMPRE INCLUIDOS
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-270">
          {bonuses.map((bonus, i) => {
          const Icon = bonus.icon;
          const numberLabel = String(i + 1).padStart(2, '0');
          return <div key={i} className="glass-panel rounded-2xl p-5 border-brand-pink/30 relative overflow-hidden bg-white/90 flex flex-col" data-id="element-271">
                <div className={`absolute top-3 left-3 ${bonus.bgColor} border ${bonus.borderColor} ${bonus.color} text-[11px] font-mono font-bold px-2 py-0.5 rounded-md`} data-id="element-272">
                  {numberLabel}
                </div>
                <div className="absolute top-0 right-0 bg-brand-gold text-brand-dark text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-273">
                  GRATIS
                </div>
                <Icon className={`w-7 h-7 ${bonus.color} mb-3 mt-6`} data-id="element-274" />
                <h4 className="text-base font-serif font-bold mb-1 pr-14 leading-tight text-brand-text" data-id="element-275">
                  {bonus.title}
                </h4>
                <p className={`${bonus.color} text-xs font-medium mb-3`} data-id="element-276">
                  {bonus.subtitle}
                </p>
                <p className="text-brand-text/80 mb-3 text-xs flex-grow" data-id="element-277">
                  {bonus.desc}
                </p>
                <div className="text-xs font-medium text-brand-pinkDark mb-2" data-id="element-278">
                  {bonus.result}
                </div>
                <div className="text-xs text-brand-text/50 mt-auto" data-id="element-279">
                  <span className="line-through" data-id="element-280">{bonus.price}</span>
                  <span className="ml-2 font-bold text-brand-goldDark" data-id="element-281">
                    → GRATIS
                  </span>
                </div>
              </div>;
        })}
        </div>

        <div className="text-center mt-8" data-id="element-282">
          <div className="inline-block glass-panel px-6 py-3 rounded-full border-brand-pink/30 bg-white/80" data-id="element-283">
            <p className="text-sm md:text-base font-medium text-brand-text/80" data-id="element-284">
              Valor total bonos{' '}
              <span className="line-through text-brand-text/50" data-id="element-285">$38.970</span>{' '}
              <span className="text-brand-pink font-bold" data-id="element-286">
                → GRATIS con tu Santuario Digital
              </span>
            </p>
          </div>
        </div>
      </div>

      <Pricing data-id="element-287" />
    </Section>;
};